import { SharedSkillService } from '../../skill-repository/shared-skill.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SkillRepoEmployeesService } from '../../skill-repo-employees/skill-repo-employees.service';
import { OthersService } from '../others/othersDataService';
import { CompetenciesService } from '../competencies.service';
import { R } from '@angular/cdk/keycodes';
import { Component, OnInit, Output } from '@angular/core';
@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.css']
})
export class ResourcesComponent implements OnInit {

  constructor(private sharedskillservice: SharedSkillService, private router: Router, private route: ActivatedRoute, private skillservice: SkillRepoEmployeesService, private othersService: OthersService, private compservice: CompetenciesService) { }
  competencyname: any;
  name: string;
  compId: number;
  resource: number = 1;
  subCompetencyid: number;
  subCompetencyName: any


  ngOnInit() {
    this.compservice.profileStatus$.subscribe(value => {
      this.compId = value;
      if (this.compId == null) {
        this.compId=Number(sessionStorage.getItem("compId"))}
    })
    this.compservice.competencyName$.subscribe(x => { this.competencyname = x 
      if (this.competencyname == null ||this.competencyname == "") {
        this.competencyname = sessionStorage.getItem("compTitle")
      }}
      )

    this.othersService.id$.subscribe(id => {
      this.subCompetencyid = id;
      if (this.subCompetencyid == null ||this.subCompetencyid == 0 ) {
        this.subCompetencyid = Number(sessionStorage.getItem("SubcompId"))
      }

    });
    this.othersService.name$.subscribe(name => {
      this.subCompetencyName = name;
      if (this.subCompetencyName == null || this.subCompetencyName == '') {
        this.subCompetencyName = sessionStorage.getItem("SubcompTitle")
      }
      this.handleNameChange();
    });

    //console.log("this.resourcewidgetdata yash : ",this.resourceWidgetData);
    
  }
  resource_navigate(){
    this.router.navigate(["Home/Skill Repository"]);
  }
  handleNameChange() {
    //this.getResourceWidgetCount();
    this.compservice.serviceId$.subscribe(serviceId => {
      if (serviceId) {
        this.getResourceWidgetCount(serviceId);
      }
    });
    
  }

  resourceWidgetData: any;
  getResourceWidgetCount(serviceId: number) {
    this.compservice.GetResourceWidgetCount(this.compId, serviceId, true).subscribe(res => {
      this.resourceWidgetData = res;
    })
  }

  Total() {

      let filter = 5;
      sessionStorage.setItem("resource",String(this.resource))
      sessionStorage.setItem("filter",String(filter))
      this.sharedskillservice.setpagenavigationId({
      resource: this.resource,
      competencyId: this.compId,
      options: filter,
      competencyName : this.competencyname,
      subCompId: this.subCompetencyid
    });
    this.skillservice.resourceroute(this.competencyname, this.subCompetencyid, this.subCompetencyName, filter)
  }
  Available() {
      let filter = 1;
      sessionStorage.setItem("resource",String(this.resource))
      sessionStorage.setItem("filter",String(filter))
      this.sharedskillservice.setpagenavigationId({
      resource: this.resource,
      competencyId: this.compId,
      options: filter,
      competencyName : this.competencyname,
      subCompId: this.subCompetencyid

    });
    this.skillservice.resourceroute(this.competencyname, this.subCompetencyid, this.subCompetencyName, filter)
  }
  Blocked() {
    let filter = 2;
      sessionStorage.setItem("resource",String(this.resource))
      sessionStorage.setItem("filter",String(filter))
    this.sharedskillservice.setpagenavigationId({
      resource: this.resource,
      competencyId: this.compId,
      options: filter,
      competencyName : this.competencyname,
      subCompId: this.subCompetencyid
    });
    this.skillservice.resourceroute(this.competencyname, this.subCompetencyid, this.subCompetencyName, filter)
  }

  Noticeperiod() {
    let filter = 3
      sessionStorage.setItem("resource",String(this.resource))
      sessionStorage.setItem("filter",String(filter))
    this.sharedskillservice.setpagenavigationId({
      resource: this.resource,
      competencyId: this.compId,
      options: filter,
      competencyName : this.competencyname,
      subCompId: this.subCompetencyid
    });
    this.skillservice.resourceroute(this.competencyname, this.subCompetencyid, this.subCompetencyName, filter)
  }

  Aging() {
    let filter = 4;
      sessionStorage.setItem("resource",String(this.resource))
      sessionStorage.setItem("filter",String(filter))
      this.sharedskillservice.setpagenavigationId({
      resource: this.resource,
      competencyId: this.compId,
      options: filter,
      competencyName : this.competencyname,
      subCompId: this.subCompetencyid
    });
    this.skillservice.resourceroute(this.competencyname, this.subCompetencyid, this.subCompetencyName, filter)
  }
}
